import { useMemo } from 'react';
import { useOtherChannelCandidates } from '@/entities/outreach-candidate';
import { OtherChannelList } from './OtherChannelList';

/** 섭외 방법이 「다른 매체」 일 때 선다 — 고른 순간에 이메일 없는 후보를 불러온다. */
export function OtherChannelSection({
  scenarioId,
  queryId,
}: {
  scenarioId: string;
  queryId: string | null;
}) {
  const other = useOtherChannelCandidates(scenarioId, queryId, { enabled: true });
  const items = useMemo(() => other.data?.pages.flatMap((page) => page.items) ?? [], [other.data]);
  return (
    <OtherChannelList
      items={items}
      loading={other.isFetching}
      failed={other.isError}
      hasMore={other.hasNextPage}
      onMore={() => void other.fetchNextPage()}
    />
  );
}
